import React from 'react';
import { makeStyles } from '@material-ui/core';
import { clsx, colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';

interface Props {
  children?: React.ReactNode;
  color?: 'primary' | 'default' | 'error';
}
const QuotationHistoryBar = ({ children, color = 'default' }: Props) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.root, {
        primary: color === 'primary',
        error: color === 'error'
      })}
    >
      <CustomizedTypography
        className="text"
        align="center"
        variant="subtitle2"
        color={color === 'default' ? 'textPrimary' : color}
      >
        {children}
      </CustomizedTypography>
    </div>
  );
};

export default QuotationHistoryBar;

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colorSet.gray100,
    borderRadius: 8,
    padding: 12,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%'
    },
    '& .text': {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: 20,
        height: 20,
        marginRight: 4
      }
    },
    '&.primary': {
      backgroundColor: colorSet.primary100
    },
    '&.error': {
      backgroundColor: colorSet.errorBackGround
    }
  }
}));
